import { useState } from 'react';

import { Stack } from '@mui/material';

import OptionCard from '@/components/wrapped/OptionCard';
import StepScreen from '@/karehero-app/access/StepScreen';
import { ACCOUNT_EMAIL } from '@/karehero-app/access/AccountSheet.content';

// First screen after the Kinde drawer closes. Instead of production's
// "Account Created" interstitial, it welcomes the member and asks how their
// access is funded, so the next step only asks for the one thing we need.

export type FundingChoice = 'work' | 'partner' | 'payroll';

const OPTIONS: { value: FundingChoice; label: string }[] = [
  { value: 'work', label: "I'm getting this through work" },
  { value: 'partner', label: 'I have a partner code' },
  { value: 'payroll', label: 'I have a payroll ID' },
];

const FundingScreen = ({
  onContinue,
  onSignOut,
  email = ACCOUNT_EMAIL,
  initialSheetOpen = false,
  initialChoice = null,
}: {
  onContinue: (choice: FundingChoice) => void;
  onSignOut?: () => void;
  // The freshly registered Kinde account, named in the account sheet.
  email?: string;
  /** Jump-state for stories: open on the account sheet (the stuck-user rescue). */
  initialSheetOpen?: boolean;
  /** Jump-state for handover minis: show the screen with an answer picked. */
  initialChoice?: FundingChoice | null;
}) => {
  const [choice, setChoice] = useState<FundingChoice | null>(initialChoice);

  return (
    <StepScreen
      title='Welcome to KareHero'
      description='First, tell us how your access is funded.'
      primaryLabel='Continue'
      isPrimaryDisabled={!choice}
      onPrimary={() => choice && onContinue(choice)}
      account={{ email, onSignOut, initialSheetOpen }}
    >
      <Stack spacing={1.5}>
        {OPTIONS.map((option) => (
          <OptionCard
            key={option.value}
            control='radio'
            selected={choice === option.value}
            onClick={() => setChoice(option.value)}
            label={option.label}
          />
        ))}
      </Stack>
    </StepScreen>
  );
};

export default FundingScreen;
